import { sanitizeRichEmailHtml } from './sanitizeEmailBody';

const STORAGE_KEY = 'ums-email-reply-forward-intro-html';

/** Default: one empty paragraph so the cursor can sit above the signature. */
export const DEFAULT_REPLY_FORWARD_INTRO_HTML = '<p><br></p>';

export function sanitizeReplyForwardIntroHtml(raw: string): string {
  const trimmed = raw.trim();
  if (!trimmed) return DEFAULT_REPLY_FORWARD_INTRO_HTML;
  const out = sanitizeRichEmailHtml(trimmed);
  if (!out.trim()) return DEFAULT_REPLY_FORWARD_INTRO_HTML;
  return out;
}

export function getReplyForwardIntroHtml(): string {
  if (typeof window === 'undefined') return DEFAULT_REPLY_FORWARD_INTRO_HTML;
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored == null || stored.trim() === '') return DEFAULT_REPLY_FORWARD_INTRO_HTML;
    return sanitizeReplyForwardIntroHtml(stored);
  } catch {
    return DEFAULT_REPLY_FORWARD_INTRO_HTML;
  }
}

/** Raw stored value for the editor (unsanitized); falls back to default HTML. */
export function getReplyForwardIntroRawForEdit(): string {
  if (typeof window === 'undefined') return DEFAULT_REPLY_FORWARD_INTRO_HTML;
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored == null || stored.trim() === '') return DEFAULT_REPLY_FORWARD_INTRO_HTML;
    return stored;
  } catch {
    return DEFAULT_REPLY_FORWARD_INTRO_HTML;
  }
}

/** Persist intro for new reply/forward compose windows. */
export function setReplyForwardIntroHtml(html: string): void {
  const sanitized = sanitizeReplyForwardIntroHtml(html);
  localStorage.setItem(STORAGE_KEY, sanitized);
}

export function resetReplyForwardIntroHtml(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}

/**
 * Replace the leading segment (before signature or before reply/forward header) with new intro HTML.
 */
export function replaceReplyForwardIntroInBody(currentHtml: string, newIntroHtml: string): string {
  const intro = sanitizeReplyForwardIntroHtml(newIntroHtml);
  const html = currentHtml ?? '';
  const sigMatch = html.match(/<div[^>]*\bclass="[^"]*email-signature[^"]*"/i);
  const sigAt = sigMatch?.index;
  if (sigAt != null && sigAt >= 0) {
    return intro + html.slice(sigAt);
  }
  const rawIdx = html.indexOf('<div data-slate-raw-html="true"');
  if (rawIdx !== -1) {
    return intro + html.slice(rawIdx);
  }
  return intro + html;
}
